define("shared/components/shared/ui/mobile-redirect-prompt", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cIC--card" ...attributes>
    <div class="cIC--cardHeader u--p__b__xs">
      <p class="cIC--cardHeader__title">
        <span class="u--m__r__sm">{{t "plans.mobile.redirect.icon"}}</span>
        {{this.title}}
      </p>
    </div>
    <div class="cIC--cardBody">
      <p class="u--m__b__0">
        {{this.description}}
        <Shared::Ui::Button
          @class="u--p__0 u--text--hl"
          @onClick={{this.openMobileRedirectModal}}
          @text={{t "shared_phrases.learn_more"}}
          @variant="unstyled"
        />
      </p>
    </div>
  </div>
  */
  {
    "id": "PThZIU4C",
    "block": "[[[11,0],[24,0,\"cIC--card\"],[17,1],[12],[1,\"\\n  \"],[10,0],[14,0,\"cIC--cardHeader u--p__b__xs\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"cIC--cardHeader__title\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--m__r__sm\"],[12],[1,[28,[35,0],[\"plans.mobile.redirect.icon\"],null]],[13],[1,\"\\n      \"],[1,[30,0,[\"title\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"cIC--cardBody\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n      \"],[1,[30,0,[\"description\"]]],[1,\"\\n      \"],[8,[39,1],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--p__0 u--text--hl\",[30,0,[\"openMobileRedirectModal\"]],[28,[37,0],[\"shared_phrases.learn_more\"],null],\"unstyled\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\"],false,[\"t\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/ui/mobile-redirect-prompt.hbs",
    "isStrictMode": false
  });
  let MobileRedirectPromptComponent = _exports.default = (_class = class MobileRedirectPromptComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "subscriptions", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
    }
    get title() {
      return this.args.title ?? this.intl.t('plans.mobile.redirect.title', {
        platform: this.subscriptions.platform
      });
    }
    get description() {
      return this.args.description ?? this.intl.t('plans.mobile.redirect.description', {
        platform: this.subscriptions.platform
      });
    }
    openMobileRedirectModal() {
      this.subscriptions.openMobileRedirectModal();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openMobileRedirectModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openMobileRedirectModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MobileRedirectPromptComponent);
});